import { makeStyles } from "@material-ui/core/styles";

const drawerWidth = 250;

export const mainLayoutStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      display: "none",
    },
    display: "none",
  },
  nav: {
    "& .MuiListItemIcon-root": {
      minWidth: "41px",
      marginLeft: "10px",
    },
    "& .MuiTypography-body1": {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "40px",
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#FBFBFB",

    background: "#FFFFFF",
    boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.05)",
    // width: "17%",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    [theme.breakpoints.up("sm")]: {
      // paddingTop: "2.3rem",
    },
    // paddingTop: "5rem",
    // marginTop: "4rem",
    paddingTop: "0px",
    paddingLeft: "0px",
    paddingRight: "0px",
  },
}));
